export class Closure {
  balance: number;
  created: Date;
  id: number;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      if(data.created){
        this.created = data.created ? new Date(data.created) : null;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Closure.ts